module.exports = __webpack_public_path__ + "img/4.01b1a53d.png";